import React from 'react';
import { FiCode, FiDatabase, FiEdit, FiUsers, FiAlertTriangle, FiShield, FiSlash, FiMail } from 'react-icons/fi';
import SEO from '../components/SEO';
import '../styles/legal.css';
import config from '../config';

const TermsPage = () => (
    <div className="legal-bento-container py-5">
        <SEO
            title="Terms and Conditions"
            description="Terms and conditions for accessing, using, or contributing to the electrospinning dataset platform."
        />

        <header className="text-center mb-5 bento-header">
            <h1 className="display-4 font-weight-bold">Terms and Conditions</h1>
            <p className="lead text-muted legal-intro-bento">
                By accessing, using, or contributing to this open-source platform, you agree to the following terms and guidelines.
            </p>
            <span className="legal-date">Last Updated: December 21, 2025</span>
        </header>

        <div className="bento-grid-legal">

            <section className="legal-tile tile-accent tile-full">
                <h2><FiCode /> 1. Open Source Use</h2>
                <ul className="legal-list">
                    <li><strong>Free Use:</strong> The datasets and platform are provided under an open-source license, meaning they are free to use, modify, and distribute for academic, research, and non-commercial purposes.</li>
                    <li><strong>Attribution:</strong> When using or redistributing the datasets, proper attribution must be given to the authors and the platform. Please cite this platform and its associated research in your publications or derivatives.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiDatabase /> 2. Data License</h2>
                <ul className="legal-list">
                    <li><strong>CC0 License:</strong> All datasets on this platform are released under a <strong>CC0 Public Domain Dedication</strong> (or equivalent open license). This means you may use, share, and modify the data without any restrictions, as long as proper attribution is provided.</li>
                    <li><strong>Non-Commercial Use:</strong> While the data is freely available, it must not be used for commercial purposes unless explicitly authorized by the platform developers.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiEdit /> 3. Moderation of Datasets</h2>
                <ul className="legal-list">
                    <li><strong>Moderation Process:</strong> All datasets submitted to the platform will undergo a moderation process to ensure they meet our quality standards and comply with ethical research practices.</li>
                    <li><strong>Approval for Publication:</strong> Datasets will be reviewed and approved before they are made publicly available on the platform.</li>
                    <li><strong>Responsibility:</strong> Contributors are responsible for ensuring their datasets meet the necessary ethical and legal guidelines before submission.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiUsers /> 4. Open Contributions</h2>
                <ul className="legal-list">
                    <li><strong>Community Contributions:</strong> This platform thrives on community-driven contributions. By submitting datasets, you grant others the right to use, share, and build upon your contributions.</li>
                    <li><strong>Data Ownership:</strong> You retain ownership of any datasets you contribute, but agree to release them for free use under the platform's open-source license.</li>
                    <li><strong>Code Contributions:</strong> By contributing to the platform's codebase, you agree to license your contributions under the project's main license (e.g., MIT).</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiAlertTriangle /> 5. Data Quality and No Warranty</h2>
                <ul className="legal-list">
                    <li><strong>Dataset Integrity:</strong> While datasets undergo moderation, we do not guarantee the accuracy, completeness, or fitness for any specific purpose.</li>
                    <li><strong>No Warranty:</strong> All datasets are provided "as is" without warranties of any kind. Use them at your own risk.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiShield /> 6. Ethical Use</h2>
                <ul className="legal-list">
                    <li><strong>Responsible Use:</strong> You agree to use the datasets and platform in an ethical and responsible manner. Harmful, illegal, or unethical activities are strictly prohibited.</li>
                    <li><strong>Compliance:</strong> Users must comply with all relevant laws and regulations, including applicable data privacy laws.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiSlash /> 7. Limitation of Liability</h2>
                <ul className="legal-list">
                    <li><strong>No Liability:</strong> The platform developers and contributors are not liable for any damages, losses, or issues arising from the use or misuse of the datasets or the platform.</li>
                </ul>
            </section>

            <section className="legal-tile tile-accent tile-full text-center">
                <h2><FiMail /> 8. Contact and Permissions</h2>
                <p className="mb-0">
                    If you have any questions about these terms, the platform, or data usage, please contact us at <a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a>.
                </p>
            </section>

        </div>
    </div>
);

export default TermsPage;
